import truncate from 'lodash/truncate';
import moment from 'moment-timezone';
/**
 * Formats the chart category as a date, according to the granularity.
 *
 * @param value The initial value of the category, which should be an ISO
 *   datetime string.
 * @param granularity The selected chart granularity. If not specified but the
 *   value is a valid ISO date, it defaults to formatting as "day".
 * @param options Additional formatting options.
 */
export const formatDateCategory = (value, granularity = 'D', { long = false, timezone = moment.tz.guess(), } = {}) => {
    const date = moment.tz(value, timezone);
    const isUS = moment.locale() === 'en';
    const formatDay = (d) => {
        if (long)
            return d.format('ddd, ll');
        return d.format(isUS ? 'MMM DD' : 'DD MMM');
    };
    switch (granularity) {
        case 'H':
            return date.format('LT');
        case 'W':
            return long
                ? `${formatDay(date)} - ${formatDay(date.endOf('week'))} (W${date.format('W')})`
                : formatDay(date);
        case 'M':
            return date.format(long ? 'MMM YYYY' : 'MMM');
        case 'D':
        default:
            return formatDay(date);
    }
};
/**
 * Formats the chart category as plain text, truncated if `limit` is specified.
 *
 * @param value The initial text value of the category.
 * @param options The options for truncating the text.
 */
export const formatTextCategory = (value, options = {}) => {
    if (!(options === null || options === void 0 ? void 0 : options.length))
        return value;
    return truncate(value, options);
};
